import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { TokenStorage } from './token-storage';
import { UsersService } from '../services/users.service';

/**
 * Intercepteur Http permettant d'ajouter dans les en-têtes des requêtes HTTP le token d'authentification.
 */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    /**
     * Constructeur.
     * @param tokenStorage : Instance du service de stockage du token d'authentification sur le navigateur.
     * @param usersService ; Instance du service des utilisateurs
     */
    public constructor(private tokenStorage: TokenStorage, private usersService: UsersService) {}

    /**
     * Intercepte la requête.
     * @param request : Instance de la requête.
     * @param next : Instance de l'interceptor suivant.
     */
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Ajoute le token Bearer dans le header "Authorization" et le compte dans le header "CesarAccount"
        const token = this.tokenStorage.getToken();
        const user = this.usersService.getSessionCurrentUser();
        if (token) {
            request = request.clone({
                setHeaders: {
                    Authorization: token,
                },
            });
        }

        if (user) {
            request = request.clone({
                setHeaders: {
                    CesarAccount: user.account,
                },
            });
        }

        return next.handle(request);
    }
}
